<template>
    <div>
        <Header />
        <Brands />
        <div v-if="$store.state.hostName !== 'Q'">
            <Footer />
        </div>
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Brands from '@/components/Brands.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'BrandsView',

  components: {
    Header,
    Brands,
    Footer
  }
}
</script>
